import { render, staticRenderFns } from "./CreateNoteModal.vue?vue&type=template&id=666b145d&scoped=true&"
import script from "./CreateNoteModal.vue?vue&type=script&lang=js&"
export * from "./CreateNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666b145d",
  null
  
)

export default component.exports